import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Cookies, withCookies } from 'react-cookie';

import CookieConsentBarContent from './CookieConsentBarContent';

class CookieConsentBar extends Component {
  static propTypes = {
    cookies: PropTypes.instanceOf(Cookies).isRequired
  }

  componentWillMount() {
    const { cookies } = this.props;

    const hasAccepted = !!cookies.get('cookies-accepted');

    this.setState({
      hasAccepted,
    });
  }

  onAccept() {
    const { cookies } = this.props;

    this.setState({
      hasAccepted: true,
    });
    cookies.set('cookies-accepted', 'true', { maxAge: 2147483647 });
  }

  render() {
    const {
      hasAccepted,
    } = this.state;

    return (
      <CookieConsentBarContent accepted={hasAccepted} onAccept={() => this.onAccept()} />
    );
  }
}

export default withCookies(CookieConsentBar);



// WEBPACK FOOTER //
// ./src/components/CookieConsentBar/CookieConsentBar.jsx